module.exports = __webpack_public_path__ + "static/media/principals.7bb35671.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/img/com/principals.jpg
 ** module id = 141
 ** module chunks = 0
 **/